import Loading from '@/assets/lottie/loading.json';
import OnboardingOverlay from '@/components/Onboarding';
import { useAuth } from '@/contexts/AuthContext';
import Lottie from 'lottie-react';

const OnboardingPage = () => {
    const { workspaceMembers :{isLoadingInvitations} } = useAuth();

    return (
        <div className="w-full h-screen bg-[#F8F9FB] flex items-center justify-center">
            {isLoadingInvitations ? (
                <div
                    style={{
                        zIndex: 9999,
                        position: 'absolute',
                        background: '#fff',
                        top: 0, left: 0, right: 0, bottom: 0, display: 'flex', justifyContent: 'center', alignItems: 'center'
                    }}
                >
                    <Lottie animationData={Loading} />
                </div>
            ) : null}
            {/* 这个页面主要作为 OnboardingOverlay 的背景载体 */}
            <OnboardingOverlay />
        </div>
    );
};

export default OnboardingPage;
